import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export interface PagingConfig {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
};

@Component({
    selector: "app-table",
    templateUrl: "./table-wrapper.component.html",
    styleUrls: ["./table-wrapper.component.scss"]
})
export class TableWrapperComponent implements OnInit {

    currentPage: number = 1;
    itemsPerPage: number = 10;
    totalItems: number = 0;
    tableSize: number[] = [10, 15, 20];
    pagingConfig: PagingConfig = {} as PagingConfig;
    filterValues = {};

    @Input() 
    set filterPayload(val: any) {
        this.filterValues = val || {};
        this.filterChange.emit(this.filterValues);
    }
    @Input() tableData: any[] = [];
    @Input() columnDef: any[] = [];
    @Input() set defaultParams(val: any) {
        this.pagingConfig = {
            itemsPerPage: val ? val.itemsPerPage : this.itemsPerPage,
            currentPage: val ? val.currentPage : this.currentPage,
            totalItems: val ? val.totalItems : this.totalItems
        };
    };
    @Input() frameworkComponents: any = {};

    @Output() fetchData: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitRowClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() filterChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() sortApply: EventEmitter<any> = new EventEmitter<any>();

    constructor() {

    }

    ngOnInit(): void {
        this.pagingConfig = {
            itemsPerPage: this.defaultParams ? this.defaultParams.itemsPerPage : this.itemsPerPage,
            currentPage: this.defaultParams ? this.defaultParams.currentPage : this.currentPage,
            totalItems: this.defaultParams ? this.defaultParams.totalItems : this.totalItems
        }
    }

    onTableDataChange(event: any) {
        this.pagingConfig.currentPage = Number(event);
        this.fetchData.emit(this.pagingConfig);
    }
    onTableSizeChange(event: any): void {
        this.pagingConfig.itemsPerPage = Number(event.target.value);
        this.pagingConfig.currentPage = 1;
        this.fetchData.emit(this.pagingConfig);
    }

    onSearchInputChange(event: any, col: any): void {
        const searchText = event.target.value;
        /*if(!searchText && this.filterValues?.hasOwnProperty?.[col.field]) {
            delete this.filterValues[col.field];
        } else if(searchText && searchText?.length >= 3) {*/
            this.filterValues = {...this.filterValues, ...{[col.filterValue]: searchText}};
            if(!searchText) {
                delete this.filterValues[col.filterValue];
            }
        //}
        this.filterChange.emit(this.filterValues);
    }

    onClick(row: any) {
        this.emitRowClick.emit(row);
    }

    onSortColumn(col: any): void {
        this.columnDef.forEach(c => {
            if (c === col) {
                if (!c.sortOrder || c.sortOrder === '') {
                    c.sortOrder = 'ASC';
                } else if (c.sortOrder === 'ASC') {
                    c.sortOrder = 'DESC';
                } else {
                    c.sortOrder = 'ASC';
                }
            } else {
                c.sortOrder = '';
            }
        });
        const sortedCol = this.columnDef.find(c => c.sortOrder);
        if (sortedCol) {
            this.sortApply.emit({ field: sortedCol.field, sortOrder: sortedCol.sortOrder });
        } else {
            this.sortApply.emit(null);
        }
    }

    trackByRow(index: number, row: any): any {
        return row?.studentCourseApplicationId || row?.id || index;
    }

}